class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.querySelector('#cart-notification');
    this.header = document.querySelector('sticky-header');
    this.links = document.querySelector('.po-cart-notification__links');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.domBody = document.querySelector('body');

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.domBody.classList.add('tw-overflow-y-hidden');
    this.notification.classList.add('active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );
  }


  close() {
    this.domBody.classList.remove('tw-overflow-y-hidden');
    this.notification.classList.remove('active');
    removeTrapFocus(this.notification);
  }

  updateAccessorySpacing(){
    if(this.links.classList.contains('po-cart-notification__links-fixed')) return;
    
    this.links.classList.add('po-cart-notification__links-fixed');
    const accessories = document.querySelector('.po-minicart-accessories-container');
    const linksHeight = this.links.clientHeight;
    accessories.style.marginBottom = linksHeight + 'px';
  }

  renderContents(parsedState) {
    // This way, section rendering is supported in the case of fetching using formData or JSON.
    // If fetch with JSON, parsedState.items?.[0]?.key it only renders the first item (main product)
    this.cartItemKey = parsedState.key ? parsedState.key : parsedState.items?.[0]?.key;
    
    this.getSectionsToRender().forEach((section) => {
      if (section.selector) {
        const tempDOM = new DOMParser().parseFromString(parsedState.sections[section.id], 'text/html');
        const newItem = tempDOM.querySelector(section.selector);

        if (!newItem) return;

        const newVariantId = newItem.getAttribute('data-variant-id');

        const existingItem = document.querySelector(
          `#${section.id} [data-variant-id="${newVariantId}"]`
        );
        
        if (existingItem) existingItem.remove();

        const accessoriesSlide = document.querySelector(
          `.swiper-slide[data-variant-id="${newVariantId}"]`
        );

        if (accessoriesSlide) {
          const swiperInstance = accessoriesSlide.closest('.swiper')?.swiper;
          accessoriesSlide.remove();
          if (swiperInstance) swiperInstance.update();
        }

        const container = document.getElementById(section.id);
        if (container) container.appendChild(newItem);

        if(parsedState.product_type === 'Accessories') {
            if(window.matchMedia('(max-width: 768px)').matches) {
                this.updateAccessorySpacing();
            }

            const event = new CustomEvent('minicart:updated', {});
            window.dispatchEvent(event);
        }

      } else {
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'po-cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
